import {CompositionBadgeSize} from '@dms/api/sales';
import {CompositionImageLayer, FinancingCompositionScene} from '@dms/api/shared';

import {randomLowerCaseUUID} from 'shared/web';

// A generated badge is square; it starts at half the shorter canvas side, centered, and never
// larger than the pixels that were actually generated.
export const createGeneratedImageLayer = (
  canvas: Pick<FinancingCompositionScene['canvas'], 'width' | 'height'>,
  fileId: string,
  size: CompositionBadgeSize
): CompositionImageLayer => {
  const generatedSide = Number(size.split('x')[0]);
  const side = Math.min(Math.round(Math.min(canvas.width, canvas.height) / 2), generatedSide);

  return {
    id: randomLowerCaseUUID(),
    type: 'image',
    x: Math.round((canvas.width - side) / 2),
    y: Math.round((canvas.height - side) / 2),
    width: side,
    height: side,
    opacity: 1,
    fileId,
    fit: 'contain',
  };
};
